import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { wishlistMutations, wishlistQueryKeys } from '@as-react/common-queries';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LOCAL_STORAGE_WISH_LIST_KEY } from '../constants/StorageKeysConstants';
import LocalStorageUtil from '../util/LocalStorageUtil';
export const useWishlist = ({ loginCallback } = {}) => {
    const { defaultRequestParams, servicesEndpoint, authenticationConfig, isShopLanding } = useAemConfig();
    const queryClient = useQueryClient();
    const { wishlistLoginMutation, wishlistLogoutMutation } = wishlistMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: wishlistLogin } = useMutation(wishlistLoginMutation());
    const { mutateAsync: wishlistLogout } = useMutation(wishlistLogoutMutation());
    const login = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogin(authenticationConfig);
            queryClient.invalidateQueries({
                queryKey: wishlistQueryKeys.wishlistProducts({ showOutOfStock: !isShopLanding }),
            });
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
            loginCallback === null || loginCallback === void 0 ? void 0 : loginCallback();
        }
        catch (_a) { }
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogout(authenticationConfig);
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
        }
        catch (_a) { }
    });
    return { wishlistLogin: login, wishlistLogout: logout };
};
